function applyZipMask(input) {
    input.addEventListener('input', function(e) {
        var value = e.target.value.replace(/\D/g, '');
        
        if (value.length > 5) {
            value = value.slice(0, 5) + '-' + value.slice(5, 8);
        }
        
        e.target.value = value;
    });
}

function initZipMaskAndScroll() {
    var zipInput = document.getElementById('AddressZip');
    if (zipInput) {
        applyZipMask(zipInput);
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                var dynamicZipInput = document.getElementById('AddressZip');
                if (dynamicZipInput) {
                    applyZipMask(dynamicZipInput);
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true });

    window.addEventListener('scroll', function() {
        var whatsappIcon = document.querySelector('.WhatsAppIcon');
        if (whatsappIcon) {
            if (window.scrollY > 100) {
                whatsappIcon.classList.add('scrollDown');
            } else {
                whatsappIcon.classList.remove('scrollDown');
            }
        }
    });
}

function initQueryParamButtons() {
    if (window.location.search.indexOf('cliente-ma') !== -1) {
      var buttons = document.querySelectorAll('.btn-eventos');
      buttons.forEach(function(button) {
        button.href = "https://lp.lojamarianaamaral.com.br/clientes-varejo-ma";
      });
    }
  
    if (window.location.search.indexOf('cliente-vip-desconto-ma') !== -1) {
      var buttons = document.querySelectorAll('.btn-eventos');
      buttons.forEach(function(button) {
        button.href = "https://payment-link.pagar.me/pl_31qy6g9dmnYbR4lt6IDRA8jLwVeQxPo7";
      });
    }
}

function initMenuTextEffects() {
    const menuItems = document.querySelectorAll(".menu li a span");
  
    menuItems.forEach(link => {
      link.setAttribute("data-text", link.textContent);
  
      if (/super\s?outlet/i.test(link.textContent)) {
        link.classList.add("glitch-text");
      }
    });
}

function initWhatsAppModal() {
  'use strict';
  
  const trigger = document.querySelector('.whatsapp-trigger');
  const modal = document.getElementById('whatsappModal');
  const closeBtn = document.querySelector('.whatsapp-close');
  const contactItems = document.querySelectorAll('.whatsapp-contact-item');
  
  if (!trigger || !modal) return;
  
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    modal.classList.toggle('active');
  });
  
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      modal.classList.remove('active');
    });
  }
  
  document.addEventListener('click', function(e) {
    if (modal.classList.contains('active') && 
        !modal.contains(e.target) && 
        !trigger.contains(e.target)) {
      modal.classList.remove('active');
    }
  });
  
  contactItems.forEach(function(item) {
    item.addEventListener('click', function() {
      setTimeout(function() {
        modal.classList.remove('active');
      }, 150);
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      modal.classList.remove('active');
    }
  });
}

function runAllScripts() {
    initZipMaskAndScroll();
    initQueryParamButtons();
    initMenuTextEffects();
    initWhatsAppModal();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllScripts);
} else {
    runAllScripts();
}

if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', initWhatsAppModal);
}